// ex) A submenu plugin that appends the contents of the input element to the editor
const date = {
    // plugin name (Required)
    name: 'MeetingDate',

    // add function - It is called only once when the plugin is first run.
    // This function generates HTML to append and register the event.
    // arguments - (core : core object, targetElement : clicked button element)
    add: function (core, targetElement) {

        // Registering a namespace for caching as a plugin name in the context object
        const context = core.context;
        context.custom = {
            textElement: null
        };

        // Generate submenu HTML
        // Always bind "core" when calling a plugin function
        let listDiv = this.setSubmenu.call(core);

        /** append html */
        targetElement.parentNode.appendChild(listDiv);

          // @Required
        // You must add the "submenu" element using the "core.initMenuTarget" method.
        /** append target button menu */
        core.initMenuTarget(this.name, targetElement, listDiv);
    },

    setSubmenu: function () {
        const listDiv = this.util.createElement('DIV');
        return listDiv;
    },

    // Called after the submenu has been rendered
    on: function () {
        // Get Input value
        let value = this.util.createTextNode('::Meeting Date::');

        // insert
        this.insertNode(value);

        // set range
        this.setRange(value, value.length, value, value.length);

        // submenu off
        this.submenuOff();

        // focus
        this.focus();
    },

    onClick: function () {
        return;
    }
}
export default date;